<template>
  <v-btn
      color="blue darken-3"
      dark
      fab
      x-small
      class="ml-2"
      title="Refresh"
      @click="clickFunction"
  >
    <v-icon dark>refresh</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "RefreshButton",
  props:['clickFunction']
}
</script>

<style scoped>

</style>
